import { Popover } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { isModalOpen as isReportIssueModalOpenSelector } from 'modules/reportIssues/selectors';
import { getCustomName } from 'modules/users/selectors/currentUser';
import { ReportIssue } from 'ui/layout/ReportIssue';

import * as styles from './Header.module.less';
import HelpContent from './HelpContent';

const Help = () => {
  const customName = useSelector(getCustomName);
  const isReportIssueModalOpen = useSelector(isReportIssueModalOpenSelector);
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Popover
        trigger="click"
        placement="bottomRight"
        content={<HelpContent name={customName} setOpen={setOpen} />}
        open={open}
        onOpenChange={setOpen}
      >
        <div className={`${styles['header-usernav__wrapper']}`} data-cy="open-help">
          <i className={`fb-icon--question ${styles['header-usernav__icon']}`} />
          <span className={styles['header-usernav__label']}>
            <FormattedMessage id="help" defaultMessage="help" />
          </span>
        </div>
      </Popover>
      {isReportIssueModalOpen && <ReportIssue />}
    </>
  );
};

export default Help;
